import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { testTrainingSchema } from "features/tests/create/components/_schemas";
import { IFormCreateTestTraining } from "features/tests/create/components/_interfaces";
import TestConfig from "features/tests/create/components/TestConfig";
import AddTestButton from "features/tests/create/components/AddTestButton";
import TestPageTitle from "features/tests/create/components/TestPageTitle";
import useCreateTest from "features/tests/create/hooks/useCreateTest";
import TestPreviewTraining from "features/tests/create/components/TestPreviewTraining";
import Loading from "shared/ui/Loading";

const CreateTest = () => {
    const methods = useForm<IFormCreateTestTraining>({
        resolver: yupResolver(testTrainingSchema),
    });

    const testForm = useCreateTest({
        type: "training",
        setError: methods.setError,
        clearErrors: methods.clearErrors,
    });

    const {
        step,
        loading,
        createTestData,
        errorMessage,
        setErrorMessage,
        successMessage,
        isFormValid,
        submitTest,
    } = testForm;

    useEffect(() => {
        if (Object.keys(methods.formState.errors).length === 0 || (createTestData.individual_test.value === "2" && step === 1)) {
            setErrorMessage("");
        }
    }, [createTestData]);

    if(successMessage) {
        return (
            <>
                <TestPageTitle title="antrenament" />
                <Typography>{successMessage}</Typography>
            </>
        );
    }

    if (loading.loading && loading.name === "step") {
        return (
            <>
                <TestPageTitle title="antrenament" />
                <Box width="100%">
                    <Loading show={true} />
                </Box>
            </>
        );
    }

    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <TestConfig
                        type="training"
                        subjects={testForm.subjects}
                        grades={testForm.grades}
                        createTestData={createTestData}
                        setClassroomHandler={testForm.setClassroomHandler}
                        setSelectedStudentsHandler={testForm.setSelectedStudentsHandler}
                        setSelectAllStudentsHandler={testForm.setSelectAllStudentsHandler}
                        handleSelectChange={testForm.handleSelectChange}
                        handleInputChange={testForm.handleInputChange}
                        setSubjectHandler={testForm.setSubjectHandler}
                        setGradeHandler={testForm.setGradeHandler}
                        setSelectedCategoriesHandler={testForm.setSelectedCategoriesHandler}
                        handleTestStartDate={testForm.handleTestStartDate}
                        loading={loading}
                        errors={methods.formState.errors}
                        tags={testForm.tags}
                        setSelectedStandardsHandler={testForm.setSelectedStandardsHandler}
                    />
                );
            case 2:
                return (
                    <TestPreviewTraining items={testForm.items} handleItemReplace={testForm.handleItemReplace}/>
                );
            default:
                return null;
        }
    }

    return (
        <>
            <TestPageTitle title="antrenament" />
            <Box width="100%">
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(submitTest)} noValidate>
                        <Box mb={{xs: 5, md: 3}}>
                            {renderStepContent()}
                        </Box>
                        {isFormValid && (
                                <AddTestButton
                                    errorMessage={errorMessage}
                                    hasSteps={createTestData.individual_test.value !== "1"}
                                    step={step}
                                    totalSteps={2}
                                    itemsLength={1}
                                    confirmPreviousStep={testForm.confirmPreviousStep}
                                />
                            )}
                    </form>
                </FormProvider>
            </Box>
        </>
    );
};

export default CreateTest;
